import type { IconProps } from './types';

export const AmazonCircleIcon = (props: IconProps) => {
  const { size = 20, ref, ...other } = props;

  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      {/* Black circle background */}
      <circle cx="10" cy="10" r="10" fill="#333" />
      {/* Amazon logo centered */}
      <g transform="translate(4, 5)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.63121 6.27373C8.60552 6.23688 8.57963 6.20079 8.55388 6.16491C8.34459 5.87316 8.14511 5.59509 8.14511 5.03769V2.95975C8.14511 2.88751 8.14552 2.81576 8.14592 2.74456C8.15048 1.94785 8.15463 1.22085 7.58004 0.664692C7.08732 0.173354 6.26882 0 5.64286 0C4.4186 0 3.05288 0.473506 2.76648 2.04256C2.73616 2.20922 2.8529 2.29647 2.95873 2.32099L4.20533 2.46089C4.32207 2.45475 4.40636 2.33576 4.42896 2.21591C4.53585 1.67524 4.97249 1.41549 5.4631 1.41549C5.72769 1.41549 6.02817 1.51582 6.18478 1.76192C6.34626 2.00729 6.3437 2.33494 6.3414 2.62792C6.34114 2.66205 6.34087 2.69571 6.34087 2.72871V2.90289C6.22521 2.91629 6.10401 2.929 5.97917 2.94209C5.29932 3.01337 4.51158 3.09595 3.92162 3.36413C3.11617 3.72587 2.55057 4.46192 2.55057 5.54381C2.55057 6.93031 3.39219 7.62344 4.47578 7.62344C5.39026 7.62344 5.89072 7.39964 6.59617 6.65386C6.63141 6.70682 6.66308 6.75564 6.69291 6.80164C6.8612 7.0611 6.97104 7.23045 7.33356 7.54318C7.42927 7.59614 7.55588 7.59415 7.64069 7.51447C7.89756 7.27758 8.36397 6.85731 8.62696 6.62879C8.73198 6.53932 8.71337 6.39468 8.63121 6.27373ZM6.10024 5.67453C5.89605 6.05077 5.57081 6.28096 5.20943 6.28096C4.7167 6.28096 4.42737 5.89078 4.42737 5.3136C4.42737 4.17736 5.41072 3.97113 6.34062 3.97113C6.34062 4.03912 6.34123 4.10747 6.34184 4.176C6.3464 4.69037 6.35105 5.21493 6.10024 5.67453Z"
          fill="white"
        />
        <path
          d="M10.1687 8.54117C8.9373 9.49337 7.15155 10 5.61364 10C3.45906 10 1.51829 9.16533 0.0497396 7.77576C-0.0654527 7.6665 0.0373628 7.51729 0.175755 7.60212C1.76041 8.56856 3.71972 9.15031 5.74334 9.15031C7.10861 9.15031 8.6091 8.85364 9.98974 8.23949C10.198 8.14718 10.3726 8.38369 10.1687 8.54117Z"
          fill="white"
        />
        <path
          d="M9.24316 7.87796C9.63963 7.82776 10.5237 7.71669 10.6811 7.9278C10.8387 8.13875 10.5077 9.00619 10.3585 9.39716L10.3574 9.40002C10.3125 9.51791 10.4091 9.56497 10.5107 9.47562C11.1716 8.89665 11.3423 7.68302 11.2069 7.50714C11.0725 7.33368 9.91733 7.18351 9.21236 7.70245C9.10402 7.78293 9.12256 7.89262 9.24316 7.87796Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
